const createPhotoItem = ({ id, src, width, height, alt, info }) => ({
  id,
  src,
  width,
  height,
  alt: alt || '',
  info: info || null,
  isSelected: false,
  isLoaded: false,
});

export default createPhotoItem;
